import { SET_PASSWORD } from '@pflegia/ui/pflegia/constants/routes';

import { CANDIDATE_SECOND_STEP_REGISTRATION, SETTINGS } from '@shared/application/constants';

const EXCLUDED_ROUTES = [CANDIDATE_SECOND_STEP_REGISTRATION, SETTINGS, SET_PASSWORD];

export const shouldShowPhoneNumberModal = (candidate: { phoneNumber?: string | null }, asPath: string): boolean =>
  !candidate.phoneNumber && !EXCLUDED_ROUTES.some(route => asPath.startsWith(route));
